// extracted by mini-css-extract-plugin
export default {"container":"container___YUlHU","label":"label___ACiOi","idValue":"idValue___LVDiU"};